(() => {
  // A single modal serves original cards, AJAX collection results and arrivals repeats.
  let opening = false;
  document.addEventListener('click', async event => {
    const link = event.target.closest?.('a[data-mr-quick-shop]');
    if (!link || event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const modal = document.getElementById('mr-quick-shop-modal');
    // Real links remain usable if the theme module has not loaded.
    if (!modal || typeof modal.show !== 'function') return;
    event.preventDefault();
    if (opening || modal.open) return;
    opening = true;
    link.setAttribute('aria-busy', 'true');
    modal.setAttribute('handle', link.dataset.mrQuickShop);
    const sourceDrawer = link.closest('cart-drawer');
    const returnDrawer = sourceDrawer?.open ? sourceDrawer : null;
    if (!modal._mrCartReturnBound) {
      modal._mrCartReturnBound = true;
      modal.addEventListener('dialog:after-hide', () => {
        const drawer = modal._mrReturnToCart;
        modal._mrReturnToCart = null;
        if (drawer) Promise.resolve(modal._mrHidePromise).then(() => drawer.show()).catch(() => document.dispatchEvent(new CustomEvent('cart-drawer:error')));
      });
    }
    try {
      // A cart recommendation uses two dialogs in sequence, never two stacked
      // focus traps. Closing Quick Shop returns to the same bag and page.
      if (returnDrawer) await returnDrawer.hide();
      modal._mrReturnToCart = returnDrawer;
      await modal.show();
    } catch {
      modal._mrReturnToCart = null;
      if (returnDrawer) {
        await returnDrawer.show();
        returnDrawer.querySelector('[data-quick-shop-recovery]')?.remove();
        const notice = document.createElement('p');
        notice.dataset.quickShopRecovery = '';
        notice.className = 'mr-cart-recovery';
        notice.setAttribute('role', 'status');
        notice.textContent = 'Quick shop could not be opened. ';
        const fallback = document.createElement('a');
        fallback.href = link.href;
        fallback.className = 'link';
        fallback.textContent = 'View this product';
        notice.append(fallback);
        (returnDrawer.querySelector('.cart-drawer__complementary-products') || returnDrawer).append(notice);
      } else {
        window.location.assign(link.href);
      }
    } finally {
      opening = false;
      link.removeAttribute('aria-busy');
    }
  });

  if (customElements.get('mr-quick-shop')) return;
  class MoonreedQuickShop extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.select = this.querySelector('[data-quick-select]');
      this.form = this.querySelector('[data-quick-form]');
      this.button = this.querySelector('[data-quick-add]');
      this.status = this.querySelector('[data-quick-status]');
      if (!this.select || !this.form) return;
      this.select.addEventListener('change', () => this.sync(), {signal:this.abort.signal});
      this.form.addEventListener('submit', event => this.add(event), {signal:this.abort.signal});
      this.sync();
    }
    disconnectedCallback() { this.abort?.abort(); }
    sync() {
      const option = this.select.options[this.select.selectedIndex];
      if (!option) return;
      this.form.querySelector('[name="id"]').value = option.value;
      this.querySelector('[data-quick-price]').textContent = option.dataset.price;
      this.querySelectorAll('[data-quick-link]').forEach(link => { link.href = option.dataset.url; });
      const image = this.querySelector('[data-quick-image]');
      if (image && option.dataset.image) {
        image.src = option.dataset.image;
        image.alt = this.querySelector('.mr-quick-shop__title').textContent.trim() + ' — ' + option.textContent.trim();
      }
      const direct = option.dataset.direct === 'true';
      const available = option.dataset.available === 'true';
      this.form.hidden = !direct;
      this.button.disabled = !available || !!this.busy || !!this.checkBag;
      this.button.textContent = available ? 'Add to bag · no initials' : 'Sold out in this option';
      this.querySelector('[data-quick-stock]').textContent = available ? 'Available to order' : 'Sold out in this option';
      this.querySelector('[data-quick-note]').textContent = direct ? 'Make it yours on the product page, or add this piece without personalisation.' : 'Continue to the product page to configure this piece.';
      if (!this.checkBag) this.status.textContent = '';
    }
    bagLink(message) {
      this.status.textContent = message + ' ';
      const link = document.createElement('a');
      link.href = this.dataset.cartUrl;
      link.className = 'link';
      link.textContent = 'View bag';
      this.status.append(link);
    }
    async add(event) {
      event.preventDefault();
      const option = this.select.options[this.select.selectedIndex];
      if (this.busy || this.checkBag || this.button.disabled || this.form.hidden || option?.dataset.direct !== 'true' || option?.dataset.available !== 'true') return;
      this.busy = true;
      this.button.disabled = true;
      this.button.setAttribute('aria-busy', 'true');
      this.select.disabled = true;
      this.status.textContent = 'Adding to your bag…';
      let added = false, responseReceived = false;
      try {
        const sections = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {bubbles:true,detail:{sections}}));
        // Deliberately fresh: no initials, artwork or app properties from another form.
        const payload = {items:[{id:option.value,quantity:1}],sections:[...new Set(sections)].slice(0,5),sections_url:window.location.pathname};
        const response = await fetch(this.dataset.cartAdd, {method:'POST',headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify(payload)});
        responseReceived = true;
        added = response.ok;
        const result = await response.json();
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'This option could not be added. Please choose another option.');
        this.checkBag = true;
        if (window.themeVariables?.settings?.cartType === 'page' || !document.getElementById('cart-drawer')) {
          window.location.assign(this.dataset.cartUrl);
          return;
        }
        const cartResponse = await fetch(this.dataset.cartUrl + '.js', {cache:'no-store',headers:{Accept:'application/json'}});
        if (!cartResponse.ok) throw new Error('Cart refresh failed');
        const cart = await cartResponse.json();
        cart.sections = result.sections;
        const modal = document.getElementById('mr-quick-shop-modal');
        // The refreshed cart event below owns reopening; do not also run the
        // cancel/close return while the modal is leaving.
        if (modal) modal._mrReturnToCart = null;
        if (modal?.open) await modal.hide();
        document.documentElement.dispatchEvent(new CustomEvent('variant:add', {bubbles:true,detail:{items:result.items || [result],cart,onSuccessDo:'force_open_drawer'}}));
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {bubbles:true,detail:{baseEvent:'variant:add',cart,onSuccessDo:'force_open_drawer'}}));
      } catch (error) {
        if (added) {
          this.checkBag = true;
          this.bagLink('Added to your bag.');
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        } else if (!responseReceived) {
          this.checkBag = true;
          this.bagLink('We could not confirm the addition. Please check your bag before trying again.');
        } else {
          this.status.textContent = error.message || 'This option could not be added.';
        }
      } finally {
        this.busy = false;
        this.button.removeAttribute('aria-busy');
        this.select.disabled = false;
        this.button.disabled = !!this.checkBag || this.select.options[this.select.selectedIndex]?.dataset.available !== 'true';
      }
    }
  }
  customElements.define('mr-quick-shop', MoonreedQuickShop);
})();
